import React, { useState, useEffect } from 'react';
import { supabase } from '../../api/supabase';

let _cache = null;

export default function PrintFooter() {
  const [co, setCo] = useState(_cache);

  useEffect(() => {
    if (_cache) return;
    supabase.from('app_settings').select('value').eq('key', 'company').single()
      .then(({ data }) => { if (data?.value) { _cache = data.value; setCo(data.value); } });
  }, []);

  const name     = co?.name       || 'Travelscape Lanka (Pvt) Ltd';
  const addr1    = co?.address1   || 'No 80 B Prince Street, Colombo 11';
  const addr2    = co?.address2   || 'No 29/3 T G Jayawardena Mawatha, Colombo 03';
  const phone1   = co?.phone1     || '+94 77 178 0200';
  const phone2   = co?.phone2     || '+94 76 588 5954';
  const email1   = co?.email1     || 'info@travelscape.international';
  const email2   = co?.email2     || 'chathuritls@outlook.com';
  const visaPh   = co?.visa_phone || '+94 77 717 0764';
  const visaEm   = co?.visa_email || 'dumindatravelscape@gmail.com';

  // Rendered inside <PagedPrintView>: className="paged-footer" applies
  // `position: running(pagedFooter)` (see pagedPrint.css), so PagedJS pulls this
  // element out of flow and repeats it correctly in the bottom margin box of
  // every generated page — no `position: fixed` guesswork against the browser's
  // native print engine.
  return (
    <div className="paged-footer" style={{
      borderTop: '1.5px solid #c8a96e',
      background: '#fff',
      padding: '7px 24px 6px',
      width: '100%',
      boxSizing: 'border-box',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ fontSize: 9.5, color: '#333', lineHeight: 1.7 }}>
          <div style={{ fontWeight: 700, fontSize: 10.5, color: '#1a1a2e', marginBottom: 1 }}>{name}</div>
          <div>{addr1} &nbsp;|&nbsp; {addr2}</div>
          <div>{phone1} &nbsp;/&nbsp; {phone2} &nbsp;|&nbsp; {email1} &nbsp;/&nbsp; {email2}</div>
        </div>
        <div style={{ fontSize: 9.5, color: '#333', lineHeight: 1.7, textAlign: 'right', whiteSpace: 'nowrap' }}>
          <div style={{ fontWeight: 700, fontSize: 10.5, color: '#1a1a2e', marginBottom: 1 }}>Visa Services</div>
          <div>{visaPh}</div>
          <div>{visaEm}</div>
        </div>
      </div>
    </div>
  );
}
